import React from 'react';

const RecentlyViewed = () => {
  return (
    <div className="max-w-5xl mx-auto py-12 px-4">
      <h1 className="text-2xl font-bold mb-6 font-poppins">Recently Viewed Products</h1>
      <div className="text-gray-500 font-lato">No recently viewed products yet.</div>
    </div>
  );
};

export default RecentlyViewed;